import { ITaskUpdatedResponse } from "@/api/tasks/types";
import { updateTask } from "@/api/tasks/updateTask";
import { useMutation } from "@tanstack/react-query";

export const useUpdateTask = () => {

  const { isPending, mutateAsync: updateTaskHook, isSuccess } = useMutation({
    mutationKey: ["updateTask"],
    mutationFn: updateTask,
    onSuccess: (data: ITaskUpdatedResponse) => {
      return data;
    }
  })

  return { isPending, updateTaskHook, isSuccess };
}